import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { LuIconModule } from 'lu-icon';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { LuDatetimePickerComponent } from './lu-datetime-picker.component';

const declarations = [LuDatetimePickerComponent];

const imports = [
	CommonModule,
	LuIconModule,
	TranslateModule,
	BsDatepickerModule,
	TimepickerModule,
	FormsModule,
	PopoverModule,
	BsDropdownModule
];

@NgModule({
	imports,
	declarations,
	exports: declarations
})
export class LuDatetimePickerModule {}
